export default {
    page_title: "Kevi | Status de Orçamento",
    title: "Status de Orçamento",
    save_button: "Salvar",
    status_updated: "Status atualizados",
    status_options: {
        draft: "Rascunho",
        sent: "Enviado",
        accepted: "Aprovado",
        rejected: "Rejeitado",
        expired: "Expirado",
        cancelled: "Cancelado",
    },
};
